import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import {
  Future,
  Instrument
} from '@iv/model/instrument';
import Utils, { InstrumentTypeEnum } from '@iv/shared/utils';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { DxAutocompleteComponent } from 'devextreme-angular/ui/autocomplete';

@Component({
  selector: 'iv-live-symbols-autocomplete',
  templateUrl: './symbols-autocomplete.component.html',
  styleUrls: ['./symbols-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SymbolsAutocompleteComponent),
    multi: true
  }]
})
export class SymbolsAutocompleteComponent implements ControlValueAccessor {

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  @ViewChild(DxAutocompleteComponent, {static: false})
  private autocomplete: DxAutocompleteComponent;

  @Input()
  public dataSource: Instrument[] | Future[];

  @Input()
  public placeholder: string;

  @Input()
  public valueExpr: string;

  @Input()
  public showClearButton: boolean;

  @Input()
  public container: Element;

  @Output()
  public selectedItem = new EventEmitter<Instrument | Future>();

  @Output()
  public valueChanged = new EventEmitter<{value: string, previousValue: string}>();

  public selectedValue;

  private _disabled: boolean;
  public get disabled(): boolean {
    return this._disabled;
  }

  public set disabled(value: boolean) {
    this._disabled = value;
  }

  public autocompleteItemClick(event: { itemData: Instrument | Future }) {
    this.selectedValue = event.itemData;
    this.selectedItem.emit(event.itemData);
    this.onChange(event.itemData);
    this.onTouched();
    this.autocomplete.instance.close();
  }

  public getEntityType(item: any): InstrumentTypeEnum {
    return Utils.getStockType(item);
  }

  public opened(event: any): void {
    if (!this.container) return;

    event.component._popup.option('container', this.container);
  }

  // ----------- Методы ControlValueAccessor -----------
  // Вызовет форма, если значение изменилось извне
  public writeValue(outsideValue: Instrument | Future): void {
    if (!outsideValue) return;

    this.selectedValue = outsideValue;
    this.changeDetectorRef.detectChanges();
  }

  // Сохраняем обратный вызов для изменений
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Сохраняем обратный вызов для "касаний"
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Вызовем когда значение изменится
  private onChange(_: any): void {
  }

  // Вызовем при любом действии пользователя с контроллом
  private onTouched(): void {
  }

  // Установка состояния disabled
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
